import React, {Component} from 'react';

import OrderDetails from '../../order-details.js';
import Form from './../form.js';

export default class View extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <section className="NewReview">
        <h1>Review your purchase</h1>
        <Form
          newReview={this.props.newReview}
          changeRating={this.props.changeRating}
          changeName={this.props.changeName}
          changeComment={this.props.changeComment}
          save={this.props.save}
        />
        <a
          href="https://folksy.uservoice.com/knowledgebase/articles/54070-how-do-i-contact-the-seller-about-an-item-or-order"
        >Issue with this order?</a>
        <OrderDetails order={this.props.order}/>
      </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/reviews/new/review/view.js